export * from '@eastsideco/salvo-ts/lib/imports/formatting';

// Define additional formatting funcions below

export function myFormatFunction(foo: string) {
    return `[formatted: ${foo}]`;
}

export function formatMoney(cents: number|string|null, format: string|null = null) {
    if (format === null) {
        format = document.body?.getAttribute('data-money-format');
    }

    let centsValue: number;
    if(cents == null) { return; }

    if (typeof cents === 'string') {
        centsValue = Number(cents.replace('.', ''));
    } else {
        centsValue = cents;
    }

    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format;

    if (!formatString) { return; }

    function formatWithDelimiters(
        number: number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return '0';
        }

        const format = (number / 100.0).toFixed(precision);

        const parts = format.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    const match = formatString.match(placeholderRegex);
    if (match && match[1]) {
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(centsValue, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(centsValue, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(centsValue, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(centsValue, 0, '.', ',');
                break;
        }
    }

    return formatString.replace(placeholderRegex, value);
}
